import React from 'react';

import {Pagination, SEOWithQuery} from 'src/components/shared';
import {CATEGORY, TOPIC} from 'src/routes/paths';

import {SanityEditorial, SanityTopic, Maybe} from 'types/generated';

import {GridCard} from '../../components/editorial/GridCard';
import {SupportingContent} from '../editorial/SupportingContent';
import {InsightsNavigation} from '../insightsNavigation';
import {TopicHeader} from './TopicHeader';

//   relatedBenefitCta: JSON;
interface TopicProps {
  topic: SanityTopic;
  articles: [Maybe<SanityEditorial>];
  numPages: number;
  currentPage: number;
  limit: number;
}

const TopicTemplate: React.FC<TopicProps> = ({topic, articles, numPages, currentPage}: TopicProps) => {
  const Posts = articles.map((item, key) => {
    return (
      <GridCard
        key={key}
        cardColClasses={' grid-list_item '}
        title={item?.title}
        category={item?.editorialCategory ? item?.editorialCategory.title : item?.category}
        image={item?.heroImage}
        imageClasses={' grid-list_image '}
        contentClasses={' grid-list_content'}
        titleClasses={' type-epsilon mt-3 '}
        slug={item?.slug?.current}
        eyebrowClasses={'grid-list_eyebrow '}
        editorialCategory={item?.editorialCategory}
        isPodcast={item?.isPodcast}
      />
    );
  });
  return (
    <>
      {currentPage >= 2 ? (
        <SEOWithQuery noIndex={true} />
      ) : (
        <SEOWithQuery
          title={topic.seo?.seoMetaTitle || topic.title || undefined}
          description={topic?.seo?.seoDescription || undefined}
          image={topic?.seo?.seoImage?.asset?.url || undefined}
        />
      )}

      <div className="bg-white">
        <InsightsNavigation bgColor={'bg-white'} />
        <div className="bg-white">
          <section className="px-gutter text-black page-module-spacing" data-module="topic-hero">
            <div className="wrapper-default">
              <h2 className="type-beta text-center">{topic.title}</h2>
              {topic.description !== '' && (
                <p className="type-sm-p my-3 md:my-5 mx-auto text-center text-gray-4">{topic.description}</p>
              )}

              <div className="col-span-full flex items-center py-2 justify-center flex-wrap space-x-3 md:space-x-5 space-y-3 md:space-y-5">
                {topic.relatedCategories?.map(category => {
                  if (category?.hideFromNav != true) {
                    return (
                      <a
                        key={category?.id}
                        href={`${CATEGORY}/${category?.slug?.current}`}
                        className="button-ivory self-end"
                      >
                        {category?.title}
                      </a>
                    );
                  }
                })}
              </div>
              <TopicHeader topic={topic} />
              <div className="wrapper-default items-start grid grid-cols-4 md:grid-cols-12 col-span-full grid-spacing">
                {Posts}
                {numPages != 1 && (
                  <div className="col-span-full">
                    <div className="flex items-center justify-center w-full flex-col md:flex-row">
                      <div>
                        <Pagination
                          currentPage={currentPage}
                          numPages={numPages}
                          slug={`${TOPIC.replace('/', '')}/${topic.slug?.current}`}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default TopicTemplate;
